import React from 'react';
import classes from './block1.module.css';
import { IconStyle, IconAllInOne, IconService, IconReturn } from './FeatureIcons';
import feature5 from './feature5.png';

const FEATURES = [
    {
        id: 'style',
        title: 'Создаём индивидуальный стиль',
        label: <>Создаём<br />индивидуальный<br />стиль</>,
        description:
            'Мы не работаем по шаблону — подбираем стрижку с учётом ваших черт лица, структуры волос, образа жизни и пожеланий. Создаём стиль, который подчёркивает вашу индивидуальность и в котором вы чувствуете себя уверенно.',
        Icon: IconStyle,
    },
    {
        id: 'all-in-one',
        title: 'Всё в одном месте',
        label: <>Всё<br />в одном<br />месте</>,
        description:
            'Вы найдёте всё для создания целостного образа: от индивидуальной стрижки и моделирования бороды до маникюра, оформления бровей и профессионального ухода. Без лишних поездок и поиска салонов — экономим ваше время.',
        Icon: IconAllInOne,
    },
    {
        id: 'service',
        title: 'Безупречный сервис',
        label: <>Безупречный<br />сервис</>,
        description:
            'Каждая деталь создана для вашего комфорта: внимательные мастера, индивидуальный подход, уютная атмосфера, ароматный кофе и забота без спешки. Мы ценим ваше время и делаем каждый визит особенным.',
        Icon: IconService,
    },
    {
        id: 'return',
        title: 'К нам возвращаются снова',
        label: <>К нам<br />возвращаются<br />снова</>,
        description:
            'Более 1000 довольных клиентов уже доверили нам свой стиль. Мы ценим это доверие и каждый день подтверждаем его качеством работы, вниманием к деталям и индивидуальным подходом. Ваше возвращение — лучшая оценка нашей работы.',
        Icon: IconReturn,
    },
    {
        id: 'quality',
        title: 'Гарантия на услуги',
        label: <>Гарантия<br />на<br />услуги</>,
        description:
            'Мы уверены в качестве своей работы. Если в течение 3 дней после посещения вы заметите недочёт или захотите что-то скорректировать, мы бесплатно доведём результат до совершенства. Ваш стиль — наша ответственность.',
        Icon: null,
        image: feature5,
    },
];

const FeatureIcon = ({ item, className, imgClassName }) => {
    if (item.Icon) {
        const Icon = item.Icon;
        return <Icon className={className} />;
    }
    return <img src={item.image} alt="" className={imgClassName} />;
};

const FeatureBadges = () => {
    const [activeId, setActiveId] = React.useState(null);
    const [isTouchUi, setIsTouchUi] = React.useState(false);
    const closeTimer = React.useRef(null);
    const active = FEATURES.find((item) => item.id === activeId) || null;

    React.useEffect(() => {
        const mq = window.matchMedia('(hover: none), (pointer: coarse)');
        const sync = () => setIsTouchUi(mq.matches);
        sync();
        mq.addEventListener('change', sync);
        return () => mq.removeEventListener('change', sync);
    }, []);

    React.useEffect(() => {
        if (!activeId || !isTouchUi) return undefined;
        const onKey = (event) => {
            if (event.key === 'Escape') setActiveId(null);
        };
        document.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [activeId, isTouchUi]);

    const clearCloseTimer = () => {
        if (closeTimer.current) {
            window.clearTimeout(closeTimer.current);
            closeTimer.current = null;
        }
    };

    const openFeature = (id) => {
        clearCloseTimer();
        setActiveId(id);
    };

    const scheduleClose = () => {
        clearCloseTimer();
        closeTimer.current = window.setTimeout(() => setActiveId(null), 120);
    };

    React.useEffect(() => () => clearCloseTimer(), []);

    return (
        <>
            <div className={classes.block2}>
                {FEATURES.map((item) => (
                    <div
                        key={item.id}
                        className={`${classes.block2Item} ${activeId === item.id ? classes.block2ItemActive : ''}`}
                        onMouseEnter={!isTouchUi ? () => openFeature(item.id) : undefined}
                        onMouseLeave={!isTouchUi ? scheduleClose : undefined}
                    >
                        <button
                            type="button"
                            className={classes.block2ItemButton}
                            onClick={
                                isTouchUi
                                    ? () => setActiveId(item.id)
                                    : undefined
                            }
                            aria-haspopup="dialog"
                            aria-expanded={activeId === item.id}
                        >
                            <FeatureIcon
                                item={item}
                                className={classes.featureIcon}
                                imgClassName={classes.featureIconImg}
                            />
                            <span className={classes.block2ItemText}>{item.label}</span>
                        </button>

                        {!isTouchUi && activeId === item.id && (
                            <div
                                className={classes.featurePopover}
                                role="dialog"
                                aria-labelledby={`feature-popover-title-${item.id}`}
                                onMouseEnter={() => openFeature(item.id)}
                                onMouseLeave={scheduleClose}
                            >
                                <div className={classes.featureModalIconWrap}>
                                    <FeatureIcon
                                        item={item}
                                        className={classes.featureModalIcon}
                                        imgClassName={classes.featureModalIconImg}
                                    />
                                </div>
                                <div
                                    id={`feature-popover-title-${item.id}`}
                                    className={classes.featureModalTitle}
                                >
                                    {item.title}
                                </div>
                                <div className={classes.featureModalText}>{item.description}</div>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {isTouchUi && active && (
                <div
                    className={classes.featureModalOverlay}
                    onClick={() => setActiveId(null)}
                    role="presentation"
                >
                    <div
                        className={classes.featureModal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby={`feature-modal-title-${active.id}`}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={classes.featureModalClose}
                            onClick={() => setActiveId(null)}
                            aria-label="Закрыть"
                        >
                            ×
                        </button>
                        <div className={classes.featureModalIconWrap}>
                            <FeatureIcon
                                item={active}
                                className={classes.featureModalIcon}
                                imgClassName={classes.featureModalIconImg}
                            />
                        </div>
                        <div
                            id={`feature-modal-title-${active.id}`}
                            className={classes.featureModalTitle}
                        >
                            {active.title}
                        </div>
                        <div className={classes.featureModalText}>{active.description}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FeatureBadges;
